import axios from 'axios'
import { Message } from 'element-ui'
// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  timeout: 10000, // request timeout
})

// request拦截器
service.interceptors.request.use(
  config => {
    // config.headers['token'] = getToken(Common.curLoginUserId)
    return config
  },
  error => {
    // do something with request error
    // eslint-disable-next-line no-console
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    // eslint-disable-next-line no-console
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js